import { getOverriddenHeaderButtonLink, shouldOverrideHeaderButton } from 'frontend/utils/referral';
import { User } from 'frontend/types';

interface PremiumRedirectConfig {
  user: User;
  requestPath: string;
  axId?: string;
  targetObjectId?: number;
  targetObjectType?: string;
  targetObjectReferrer?: string;
  ignoreBlockedContent?: number;
  returnToChapter?: string;
  allowLoggedOut?: boolean;
  extraQueryParams?: { [key: string]: string };
}

function buildPremiumRedirect(config: PremiumRedirectConfig) {
  let query: { [key: string]: string } = {};
  if (config.user.is_active || config.allowLoggedOut) {
    if (config.targetObjectId && config.targetObjectType) {
      query.target_object_id = config.targetObjectId.toString();
      query.target_object_type = config.targetObjectType;
      query.target_object_referrer = config.targetObjectReferrer
        ? config.targetObjectReferrer
        : config.requestPath;
    }
    if (config.ignoreBlockedContent) {
      query.ignore_blocked_content = '1';
    }
    if (config.returnToChapter) {
      query.return_to_chapter = config.returnToChapter;
    }
    if (config.extraQueryParams) {
      Object.assign(query, config.extraQueryParams);
    }
    if (shouldOverrideHeaderButtonForReferralOrGift(config.user)) {
      return { ...getOverriddenHeaderButtonLink(), query };
    }
    return { query, name: 'payment_brilliant_square_plans' };
  }
  query = { next: '/premium/' };

  return { query, name: 'account_signup' };
}

function shouldOverrideHeaderButtonForReferralOrGift(user: User) {
  return shouldOverrideHeaderButton(user);
}

export { buildPremiumRedirect, shouldOverrideHeaderButtonForReferralOrGift };
